import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'kd-document-heading',
    templateUrl: './document-heading.component.html',
    styleUrls: ['./document-heading.component.scss']
})
export class DocumentHeadingComponent implements OnInit {

    @Input()
    element: HTMLElement;

    @Input()
    index: number;

    constructor() { }

    ngOnInit() {}
}
